// extracted by mini-css-extract-plugin
module.exports = {"styledSubmitButton":"whEPXxTN","form":"FvqoWXmh","loaderWrapper":"gcr4QSfE","isMessagePending":"nCGzQWy3","spin":"eiZ9QxAd","modesSwitcher":"Fg77FjHJ","footer":"Nh14kT2O"};